import ReactComponent from '../app/ReactComponent'
import {Link, useParams} from 'react-router-dom'
import GParallax from '../components/helpers/GParallax'
import {Button, Col, Image, Row, Spin, Statistic, Space} from 'antd'
import dayjs from 'dayjs'
import ModalBookingForm from '../components/parts/ModalBookingForm'
import ArrowLeftIcon from '../gfx/ArrowLeftIcon'
import {$t} from '../app'

export default class EventDetailPage extends ReactComponent {
  state = {
    loading: false,
    tour: {
      name: '',
      start_date: null,
      end_date: null,
      content: null,
      capacity: 0,
      capacity_booked: null,
      capacity_left: 0,
      featured_image: null
    },
    isBookingFormOpen: false
  }

  async componentDidMount() {

    this.scrollToTop()

    void this.getTourData()

  }

  async getTourData () {
    const {id} = this.props
    void this.updateState({loading: true})

    const data = await this.$app.$directus(`tours/${id}`, {
      fields: ['*', {translations: ['name', 'content']}, {featured_image: ['*']}],
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': 'cs-CZ'}
          }
        }
      }
    })

    let capacity_booked = await this.$app.$directus('tour_bookings', {
      filter: {tour: data.id, state: {'_neq': 'canceled'}},
      aggregate: {'count': '*'}
    })

    capacity_booked = capacity_booked[0].count || 0

    await this.updateState({
      tour: {
        name: data.translations[0].name,
        start_date: data.start_date,
        end_date: data.end_date,
        content: data.translations[0].content,
        capacity: data.capacity,
        capacity_booked: capacity_booked,
        capacity_left: data.capacity - capacity_booked,
        featured_image: data.featured_image.id,

      },
      loading: false,
    })

    console.log(this.state.tour)
  }

  handleBookingFormClose() {
    void this.updateState({isBookingFormOpen: false})
  }

  openBookingForm() {
    void this.updateState({isBookingFormOpen: true})
  }

  render() {
    return (
      <>
        <Spin spinning={this.state.loading} size="large">
          <section className="fullwidth centered">

            <GParallax speed={-3} options={{y: 0}} scrollTrigger={{start: 'top top'}} className="fullwidth-background">
              <Image src={this.state.tour.featured_image && `https://trailsoficeandfire.dobiland.com/assets/${this.state.tour.featured_image}?quality=30`} preview={false} style={{opacity: 0.66}}/>

            </GParallax>

            <div className="hero-gradient-bottom"></div>

            {this.state.tour.hasOwnProperty('capacity') &&

              <>
                <Row align="top" justify="center" className={'centered top-left-controls ml-2'}>
                  <Col xs={22} sm={22} md={22} lg={24}>
                    <Link to="/events"><Button type="text" shape="circle" size="large" icon={<ArrowLeftIcon/>}/></Link>
                  </Col>
                </Row>


                <Row align="bottom" justify="end" gutter={[0, 0]} style={{minHeight: 'inherit'}}>
                  <Col span={24}>
                    <div className="container centered mb-4" style={{}}>
                      <GParallax speed={1} options={{y: 0}}>
                        <h1 className="h1 text-grad mb-1">{this.state.tour.name}</h1>
                      </GParallax>

                      <Row gutter={[12, 12]}>
                        <Col xs={12} md={6} sm={12}>
                          <Statistic title="Od" value={dayjs(this.state.tour.start_date).format('D.M.YYYY')}/>
                        </Col>
                        <Col xs={12} md={6} sm={12}>
                          <Statistic title="Do" value={dayjs(this.state.tour.end_date).format('D.M.YYYY')}/>
                        </Col>
                        <Col xs={12} md={6} sm={12}>
                          <Statistic title="Kapacita" value={this.state.tour.capacity_booked} suffix={<>/&#8239;{this.state.tour.capacity}</>}/>
                        </Col>
                        <Col xs={12} md={6} sm={12}>
                          <Button type="primary" className="mt-2" disabled={this.state.tour.capacity_left === 0} onClick={() => {
                            this.openBookingForm()
                          }}><$t _="book" /></Button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

              </>
            }


          </section>

          <section className="container centered formatted">
            <div dangerouslySetInnerHTML={{__html: this.state.tour.content}} className="mt-4 mb-1"></div>
          </section>
          <section className="container centered ta-center">
            <Space size="large">
              <Link to="/events">
                <Button type="link">Zpět na přehled</Button>
              </Link>

              <Button type="primary" size="medium" onClick={() => {this.openBookingForm()}}>Rezervovat</Button>
            </Space>
          </section>
        </Spin>

        <div className="silencer medium"><br/></div>

        <ModalBookingForm
          tour_id={this.props.id}
          tour_data={this.state.tour}
          open={this.state.isBookingFormOpen}
          handleTourReload={() => {
            void this.getTourData()
          }}
          handleClose={() => {
            this.handleBookingFormClose()
          }}
        />
      </>
    )
  }
}

export function EventDetailPageHOC() {
  const {id} = useParams()

  return (<EventDetailPage id={id}/>)
}